import React, { useEffect } from "react";
import Loader from "../Components/Loader";
import {
  useAuthContext,
  AuthProvider,
  TAuthConfig,
  TRefreshTokenExpiredEvent,
} from "react-oauth2-code-pkce";
import useAuthStore from "../store/authstore";
import config from "../config";
import { useNavigate } from "react-router-dom";
import LoaderFrappe from "../Components/LoaderFrappe";
const createAuthConfig = (baseUrl, clientId) => {
  if (clientId) {
    return {
      clientId: clientId,
      authorizationEndpoint: `${baseUrl}/api/method/frappe.integrations.oauth2.authorize`,
      tokenEndpoint: `${baseUrl}/api/method/frappe.integrations.oauth2.get_token`,
      redirectUri: window.location.origin + "/", // ✅ Auto-detect current origin
      scope: "openid all",
      decodeToken: false, // ✅ Skip JWT decode to avoid undefined error
      onRefreshTokenExpire: (event) =>
        event.logIn(undefined, undefined, "popup"),
      // refreshWithScope: false,
    };
  } else return null;
};
function FrappeLogin() {
  const navigate = useNavigate();
  const baseUrl = useAuthStore((state) => state.baseUrl);
  const authConfig = createAuthConfig(baseUrl, config.CLIENT_ID);

  return (
    <div>
      {/* {authConfig ? (
        <AuthProvider key={baseUrl} authConfig={authConfig}>
          <LoaderFrappe />
        </AuthProvider>
      ) : (
        <Loader />
      )} */}
    </div>
  );
}

export default FrappeLogin;
